var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "userList" } } },
                    [_vm._v("Users")]
                  ),
                  _vm._v(" "),
                  _vm.model
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.model.email))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("table.edit")) + " User")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Roles", prop: "roles" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "", filterable: "" },
                                  model: {
                                    value: _vm.model.roles,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "roles", $$v)
                                    },
                                    expression: "model.roles"
                                  }
                                },
                                [
                                  _vm.roles
                                    ? _vm._l(_vm.roles, function(option) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option.id
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc50012", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc50012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-edit.vue
// module id = null
// module chunks = 